import './Dyson.css'
import React from 'react'
import FolderCard from './FolderCard';

const Dyson = () => { 
  return (
    <div className='dyson'>
      <div className='dysonBody'>        
        <div className='dysonProps'>          
          <FolderCard />
        </div>
      </div>      
    </div>
  )
}

export default React.memo(Dyson);